import CustomZObject from './CustomZObject.js';

export default class ZIcon extends CustomZObject {
    constructor(zobject) {
        super(zobject);

        this.newInlet("url", (msg) => this.url = msg[0]);
    }
}
